import { type FeatureState, useFeature } from '../feature'

export const useWorkflowFeature = (): FeatureState => {
  return useFeature({
    featureId: 'Feature:Workflows',
    placeholder: false,
  })
}

export const useWorkflowForCanvassFeature = (): FeatureState => {
  return useFeature({
    featureId: 'Feature:WorkflowsForCanvass',
    placeholder: false,
  })
}

export const useWorkflowMultipleFeature = (): FeatureState => {
  return useFeature({
    featureId: 'Feature:WorkflowMultiple',
    placeholder: false,
  })
}

export const useWorkflowStatsFeature = (): FeatureState => {
  return useFeature({
    featureId: 'Feature:WorkflowStats',
    placeholder: false,
  })
}

export const useWorkflowSetterCloserExecutionFeature = (): FeatureState => {
  return useFeature({
    featureId: 'Feature:WorkflowSetterCloserExecution',
    placeholder: false,
  })
}

export const useEffectiveWorkflowStatsFeature = (): FeatureState => {
  const workflowStats = useWorkflowStatsFeature()
  const setterCloserExecution = useWorkflowSetterCloserExecutionFeature()
  return {
    isLoading: workflowStats.isLoading || setterCloserExecution.isLoading,
    isEnabled: !setterCloserExecution.isEnabled && workflowStats.isEnabled,
  }
}
